import React from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './index.module.sass';

const TableComponent = (props) => {
  const { screenSize = 'desktop', tableData = [], tableItems = [], rowCallback } = props;
  const { t } = useTranslation('global');

  const months = t('months', { returnObjects: true });

  const dataCellWidth = (screenSize === 'phone' && '180px') || `${100 / tableItems.length}%`;

  function handleClick(key) {
    if (rowCallback) rowCallback(key);
  }

  const highlightFields = [
    'ordenandoGC',
    'modulosUS',
    'patrociniosDirectos',
    'totalConsultorasPatrocinando',
  ];

  const highlightIndexes = tableItems
    .map((item, index) => (highlightFields.includes(item.field) ? index : -1))
    .filter((index) => index !== -1);

  return (
    <div className={`${styles.tableContainer}`}>
      <div className={styles.table}>
        <div className={`${styles.row} ${styles.tableHeader}`}>
          {(Array.isArray(tableItems) ? tableItems : []).map((val, key) => {
            const { title = '', cellWidth = dataCellWidth } = val;
            return (
              <div className={styles.cell} style={{ width: cellWidth }} key={key}>
                {title}
              </div>
            );
          })}
        </div>
        {tableData.map((val, key) => {
          const columns = (Array.isArray(tableItems) ? tableItems : []).map((cellVal, cellKey) => {
            const {
              field = '',
              many = false,
              isLink = false,
              title = '',
              useLength = false,
              isMoney = false,
              fieldText = '',
              isImage = false,
              callbackText = '',
              cellWidth = dataCellWidth,
            } = cellVal;
            let fieldName = '';
            if (many) {
              const tmpConst = field.split(',');
              for (let i = 0; i < tmpConst.length; i++) {
                if (i > 0) fieldName += '-';
                if (tmpConst[i] === 'mes') {
                  fieldName +=
                    (tableData[key] &&
                      tableData[key][tmpConst[i]] &&
                      months[parseInt(tableData[key][tmpConst[i]]) - 1]) ||
                    '';
                } else {
                  fieldName += (tableData[key] && tableData[key][tmpConst[i]]) || '';
                }
              }
            } else if (useLength) {
              fieldName = tableData[key] && tableData[key][field] && tableData[key][field].length;
            } else {
              fieldName = tableData[key] || tableData[key] === 0 ? tableData[key][field] : '';
              if (isMoney) fieldName = `$${fieldName}`;
            }

            const cell = (
              <div
                className={`
    ${styles.cell}
    ${highlightIndexes.includes(cellKey) ? styles.highlightColumn : ''}
  `}
                style={{ width: cellWidth }}
                key={cellKey}>
                {(isLink && val?.callback && (
                  <div className={styles.callback} onClick={() => val?.callback(val?.callbackArgs)}>
                    {callbackText}
                  </div>
                )) ||
                  (isLink && (
                    <a href={fieldName} target='_blank' rel='noopener noreferrer'>
                      {(fieldName && fieldText) || title || ''}
                    </a>
                  )) ||
                  (isImage && (
                    <img
                      src={tableData[key][field]}
                      alt=''
                      style={{
                        cursor: tableData[key][field] ? 'pointer' : 'default',
                      }}
                      onClick={() => {
                        if (tableData[key][field]) {
                          window.open(tableData[key][field]);
                        }
                      }}
                    />
                  )) ||
                  fieldName}
              </div>
            );
            return cell;
          });
          return (
            <div
              className={`${styles.row} ${(rowCallback && styles.selectable) || null}`}
              key={key}
              onClick={() => handleClick(key)}>
              {columns}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TableComponent;
